module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_album-d0014ecbf8c613fa62b83679c9ba6e12.jpg";